import { useTranslation } from 'react-i18next'
import type { ListingAuditReport } from '@/lib/api/listing-builder.types'
import { RecommendationCards } from '@/components/v2/tools/amazon-listing/shared/RecommendationCards'
import {
  OverviewCard,
  StarDistribution,
  AspectCards,
  Improvements,
  CompetitorComparison,
} from '@/components/v2/tools/amazon-listing/ReviewInsightsParts'

interface ReviewInsightsProps {
  insights: ListingAuditReport['review_insights']
}

export function ReviewInsights({ insights }: ReviewInsightsProps) {
  const { t } = useTranslation()
  if (!insights) return null

  return (
    <div className="space-y-4">
      <OverviewCard overview={insights.overview} t={t} />
      {insights.overview?.star_distribution && (
        <StarDistribution dist={insights.overview.star_distribution} />
      )}
      {insights.aspects?.length > 0 && <AspectCards aspects={insights.aspects} t={t} />}
      {insights.product_improvements?.length > 0 && <Improvements items={insights.product_improvements} t={t} />}
      {insights.competitor_comparison && <CompetitorComparison data={insights.competitor_comparison} t={t} />}
      {insights.recommendations?.length > 0 && <RecommendationCards recs={insights.recommendations} t={t} />}
    </div>
  )
}
